'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var userSessionStoreCore = require('@zillow/user-session-store-core');

// user actions
var SET_USER_AUTH_TOKEN = 'USER_SESSION:ACTION:SET_USER_AUTH_TOKEN';
var SET_USER_LOGGED_IN = 'USER_SESSION:ACTION:SET_USER_LOGGED_IN';

// reg login actions
var HIDE_REG_LOGIN_LIGHTBOX = 'USER_SESSION:ACTION:HIDE_REG_LOGIN_LIGHTBOX';
var SET_REG_LOGIN_INPUT_VALUES = 'USER_SESSION:ACTION:SET_REG_LOGIN_INPUT_VALUES';
var SET_REG_LOGIN_NODE = 'USER_SESSION:ACTION:SET_REG_LOGIN_NODE';
var SET_REG_LOGIN_PATH = 'USER_SESSION:ACTION:SET_REG_LOGIN_PATH';
var SET_REG_LOGIN_REDIRECT_URL = 'USER_SESSION:ACTION:SET_REG_LOGIN_REDIRECT_URL';
var SET_REG_LOGIN_UI_CONFIG = 'USER_SESSION:ACTION:SET_REG_LOGIN_UI_CONFIG';
var SET_REG_LOGIN_UI_CONFIG_DEFAULTS = 'USER_SESSION:ACTION:SET_REG_LOGIN_UI_CONFIG_DEFAULTS';
var SHOW_REG_LOGIN_LIGHTBOX = 'USER_SESSION:ACTION:SHOW_REG_LOGIN_LIGHTBOX';

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();















var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Forwards dispatch to global store if it exists.
 * @param  {Object} action
 *                    object describing change to be made to store
 * @return {Object} dispatched action
 */
function dispatchToUserSessionStore(action) {
    if (userSessionStoreCore.hasUserSessionStore()) {
        return userSessionStoreCore.getUserSessionStore().dispatch(action);
    }

    console.error('UserSession store is undefined');
    return null;
}

/**
 * Curry for dispatchToUserSessionStore.
 * @param {String} type - action type
 * @return {Function} curried dispatch function
 */
function dispatchOfType(type) {
    return function () {
        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return dispatchToUserSessionStore(_extends({ type: type }, payload));
    };
}

/**
 * Sets user.authToken.
 * @param {String} authToken - session authToken
 * @return {Object} SET_USER_AUTH_TOKEN action
 */
function setUserAuthToken(authToken) {
    if (typeof authToken === 'undefined') {
        throw new Error('no auth token specified');
    }

    return dispatchOfType(SET_USER_AUTH_TOKEN)({ authToken: authToken });
}

/**
 * Sets user.loggedIn to true.
 * @return {Object} SET_USER_LOGGED_IN action
 */
function setUserLoggedIn() {
    return dispatchOfType(SET_USER_LOGGED_IN)();
}

/**
 * Sets regLogin.inputValues.
 * @param {Object} inputValues - reg-login form input values
 * @return {Object} SET_REG_LOGIN_INPUT_VALUES action
 */
function setRegLoginInputValues(inputValues) {
    if (typeof inputValues === 'undefined') {
        throw new Error('no input values specified');
    }

    return dispatchOfType(SET_REG_LOGIN_INPUT_VALUES)({ inputValues: inputValues });
}

/**
 * Sets regLogin.node.
 * @param {DOM Node} node  - reg-login node
 * @return {Object} SET_REG_LOGIN_NODE action
 */
function setRegLoginNode(node) {
    return dispatchOfType(SET_REG_LOGIN_NODE)({ node: node });
}

/**
 * Sets regLogin.path.
 * @param {String} path - reg-login route path
 * @return {Object} SET_REG_LOGIN_PATH action
 */
function setRegLoginPath(path) {
    if (typeof path === 'undefined') {
        throw new Error('no path specified');
    }

    return dispatchOfType(SET_REG_LOGIN_PATH)({ path: path });
}

/**
 * Sets regLogin.redirectUrl.
 * @param {String} redirectUrl - reg-login redirectUrl for post submit success
 * @return {Object} SET_REG_LOGIN_REDIRECT_URL action
 */
function setRegLoginRedirectUrl(redirectUrl) {
    if (typeof redirectUrl === 'undefined') {
        throw new Error('no redirect URL specified');
    }

    return dispatchOfType(SET_REG_LOGIN_REDIRECT_URL)({ redirectUrl: redirectUrl });
}

/**
 * Sets regLogin.uiConfig. If uiConfig is not provided values will be reset
 * to their default values
 * @param {Object} uiConfig - reg-login uiConfig
 * @return {Object} SET_REG_LOGIN_UI_CONFIG action
 */
function setRegLoginUiConfig(uiConfig) {
    return dispatchOfType(SET_REG_LOGIN_UI_CONFIG)({ uiConfig: uiConfig });
}

/**
 * Sets regLogin.uiConfig with the default values. uiConfig param will
 * override values
 * @param {Object} uiConfig - reg-login uiConfig
 * @return {Object} SET_REG_LOGIN_UI_CONFIG_DEFAULTS action
 */
function setRegLoginUiConfigDefaults(uiConfig) {
    return dispatchOfType(SET_REG_LOGIN_UI_CONFIG_DEFAULTS)({ uiConfig: uiConfig });
}

/**
 * Sets regLogin.showLightbox to true.
 * @return {Object} SHOW_REG_LOGIN_LIGHTBOX action
 */
function showRegLoginLightbox() {
    return dispatchOfType(SHOW_REG_LOGIN_LIGHTBOX)();
}

/**
 * Sets regLogin.showLightbox to false.
 * @return {Object} HIDE_REG_LOGIN_LIGHTBOX action
 */
function hideRegLoginLightbox() {
    return dispatchOfType(HIDE_REG_LOGIN_LIGHTBOX)();
}

exports['default'] = dispatchToUserSessionStore;
exports.setUserAuthToken = setUserAuthToken;
exports.setUserLoggedIn = setUserLoggedIn;
exports.setRegLoginInputValues = setRegLoginInputValues;
exports.setRegLoginNode = setRegLoginNode;
exports.setRegLoginPath = setRegLoginPath;
exports.setRegLoginRedirectUrl = setRegLoginRedirectUrl;
exports.setRegLoginUiConfig = setRegLoginUiConfig;
exports.setRegLoginUiConfigDefaults = setRegLoginUiConfigDefaults;
exports.showRegLoginLightbox = showRegLoginLightbox;
exports.hideRegLoginLightbox = hideRegLoginLightbox;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@zillow/user-session-store-actions/lib/index.js
// module id = 577
// module chunks = 1